@if (programs) {
  <div>
    <div summary>
      <div class="overlay">
        <div user-caption>
          <!-- <span FL>Today in Lake Nona, FL</span> -->
          <span FL>TODAY AT LAKEHOUSE</span>
          <span>Welcome</span>
          <div user>{{(user$ | async)?.firstName}}</div>
        </div>
        <span spacer></span>
        <div class="card">
          <span><img src="assets/images/date-banner-white.svg"></span>
          <h4>{{dateformat('monthwithdate')}} </h4>
          <div>
            {{dateformat('day')}}
            <span>&#8226;</span> {{dateformat('year')}}
          </div>
        </div>
        <div class="card">
          <span><img src="assets/images/time-banner-white.svg"></span>
          <h4>{{dateformat('time')}}</h4>
          <div>{{dateformat('part')}}</div>
        </div>
      </div>
    </div>
    <div program-list [class.has-selections]="role === 'admin' && selectedItems.size > 0">
      <div head class="dashboard-head">
        <div class="name">
          <span class="m-r-md"><img src="assets/icons/programs-title.svg" alt=""></span>
          <div>Upcoming Lakehouse Programs </div>
        </div>
        @if (role === 'admin') {
          <div>
            <app-filter [filterInput]="filterInput" (appliedDateFilter)="appliedDateFilter($event)"
            [displayFilter]="showFilter" (clearFilter)="resetToDefault()"></app-filter>
          </div>
        }
      </div>
      @if (isFilterRes) {
        <div class="no-results-filter">{{filterRes}}</div>
      } @else {
        @if (role === 'admin' && selectedItems.size > 0) {
          <div class="action-banner action-banner--sticky">
            <span class="selection-count">{{ selectedItems.size }} Program(s) Selected</span>
            @if (getBulkSelectionSummary()) {
              <span class="selection-summary">({{ getBulkSelectionSummary() }})</span>
            }
            @if (canBulkHide()) {
              <button mat-button class="action-btn action-btn--hide" (click)="bulkHide()">
                <mat-icon>visibility_off</mat-icon> Mark Confidential
              </button>
            }
            @if (canBulkShow()) {
              <button mat-button class="action-btn action-btn--show" (click)="bulkShow()">
                <mat-icon>visibility</mat-icon> Mark Visible
              </button>
            }
            <button mat-button class="action-btn action-btn--clear" (click)="clearSelection()">Clear Selection</button>
          </div>
        }
        @if (programs?.length) {
          <table class="table-fixedheader" [ngClass]="{'with-visibility-col': role === 'admin'}">
            <thead>
              @if (role === 'admin') {
                <th class="select-visibility-col width-5" (click)="sort('isConfidential')">
                  <input type="checkbox" class="visibility-col-checkbox" aria-label="Select all programs in the current list" [checked]="areAllVisibleRowsChecked()" (change)="toggleSelectAll($event)"
                    (click)="$event.stopPropagation()" />
                  <span>Visibility</span>
                  <img [ngClass]="{'active':isConfidentialAsc}" src="assets/icons/sort-by-down.svg" alt="">
                </th>
              }
              <th (click)="sort('name')" [ngClass]="role==='admin' ? 'width-20' : 'width-25' ">
                <span>Name</span>
                <img [ngClass]="{'active':isNameAsc}" src="assets/icons/sort-by-down.svg" alt="">
                <!-- <i class="material-icons" [ngClass]="{'active':isNameAsc}"> arrow_drop_down</i> -->
              </th>
              <th (click)="sort('startDate')" [ngClass]="role==='admin' ? 'width-20' : 'width-25' ">
                <span>Date</span>
                <img [ngClass]="{'active':isDateAsc}" src="assets/icons/sort-by-down.svg" alt="">
                <!-- <i class="material-icons" [ngClass]="{'active':isDateAsc}">arrow_drop_down</i> -->
              </th>
              <th (click)="sort('programType')" [ngClass]="role==='admin' ? 'width-20' : 'width-25' ">
                <span>Program Type</span>
                <img [ngClass]="{'active':programTypeAsc}" src="assets/icons/sort-by-down.svg" alt="">
                <!-- <i class="material-icons" [ngClass]="{'active':isDateAsc}">arrow_drop_down</i> -->
              </th>
              <th [ngClass]="role==='admin' ? 'width-15' : 'width-25' ">
                <span>{{(role==='admin') ? 'Sessions' : 'Events'}}</span>
              </th>
              <th>
                <span>Attendees</span>
              </th>
            </thead>
            <tbody>
              @for (item of getDisplayPrograms() | orderBy: {property: column, direction: direction, isDateSort: column === 'startDate'}; track item) {
                <tr [ngClass]="{'selected-row': isSelected(item), 'hidden-row': isProgramHidden(item)}">
                  @if (role === 'admin') {
                    <td class="select-visibility-col width-5">
                      <div>
                        <input type="checkbox" [checked]="isSelected(item)"
                          (change)="toggleSelection(item)" [attr.aria-label]="'Select program ' + (item?.name || '')" />
                        <button type="button" class="visibility-icon-btn"
                          [ngClass]="isProgramHidden(item) ? 'is-hidden' : 'is-visible'"
                          [disabled]="!canToggleIndividualConfidentiality(item)"
                          (click)="toggleProgramConfidentiality(item)"
                          [attr.aria-label]="isProgramHidden(item) ? 'Confidential program' : 'Visible program'"
                          [title]="!canToggleIndividualConfidentiality(item)
                            ? 'Clear selection to change visibility individually'
                            : (isProgramHidden(item) ? 'Confidential — click to make visible' : 'Visible — click to mark confidential')">
                          <mat-icon>{{ isProgramHidden(item) ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                      </div>
                    </td>
                  }
                  <td [ngClass]="role==='admin' ? 'width-20' : 'width-25' ">
                    <div>
                      <span><a
                      [routerLink]="'/admin/programs/'+ item.id + '/program-overview'">{{item?.name}}</a></span>
                    </div>
                  </td>
                  <td [ngClass]="role==='admin' ? 'width-20' : 'width-25' ">
                    <div>
                      <span>{{item.startDate | dateFormat : 'mmddyy'}} - {{item.endDate | dateFormat :
                      'mmddyy'}}</span>
                      <span>{{item.startDate | getdays : item.endDate}} days </span>
                    </div>
                  </td>
                  <td [ngClass]="role==='admin' ? 'width-20' : 'width-25' ">
                    <div>
                      <span>{{ item?.programType }}</span>
                    </div>
                  </td>
                  <td [ngClass]="role==='admin' ? 'width-15' : 'width-25' ">
                    <div>
                      <div>
                        <span>{{(item.counts)?.classes || 0}}</span>
                        <span>Classes</span>
                      </div>
                      <div>
                        <span>{{(item.counts)?.events || 0}}</span>
                        <span>Sessions</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div>
                      <div>
                        <span>{{(item.counts)?.participants || 0}}</span>
                        <span>Participants</span>
                      </div>
                      <div>
                        <span>{{(item.counts)?.facilitators || 0}}</span>
                        <span>Facilitators</span>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="background-white m-t-xs">
            <span class="m-l-lg">
              <error-message [errorMessage]="errorMessage"></error-message>
            </span>
          </p>
        }
      }
    </div>
  </div>
} @else {
  @if (!showLoading) {
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  }
}
